import React from "react";
import classes from "./Platform.module.css";
import { Container } from "@mui/system";
import salesforce from "../utils/images/salesforce.png";
import zoho from "../utils/images/zoho.png";
import tableau from "../utils/images/tableau.png";

const Platform = () => {
  return (
    <Container sx={{width:"100vw"}}>
      <div className={classes.topic}>
        <h1>
          <span className={classes.journey}>Platform</span>{" "}
          <span className={classes.why}>&</span>{" "}
          <span className={classes.analytics}>Integrations</span>
        </h1>
      </div>
      <div className={classes.platformCards}>
        <div className={classes.platformCard}>
          <div className={classes.salesforce}>
            <img src={salesforce} alt="logo" />
            <h4>Salesforce</h4>
          </div>
        </div>
        <div className={classes.platformCard}>
          <div className={classes.salesforce}>
            <img src={zoho} alt="logo" />
            <h4>Zoho</h4>
          </div>
        </div>
        <div className={classes.platformCard}>
          <div className={classes.salesforce}>
            <img src={tableau} alt="logo" />
            <h4>Tableau</h4>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Platform;
